function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Log from '@deephaven/log';
var log = Log.module('UserUtils');

/**
 * Retrieve a value from the AppInit config
 * @param serverConfig Server config map
 * @param key The AppInit key to retrieve
 * @returns The value for the AppInit key
 */
export function getAppInitValue(serverConfig, key) {
  return serverConfig.get("internal.webClient.appInit.".concat(key));
}

/**
 * Retrieve a user object provided the server config and overrides
 * @param serverConfig Server config map
 * @param overrides Override values for the user
 * @param permissionsOverrides Override specific permissions for the user
 * @returns The user object
 */
export function getUserFromConfig(serverConfig) {
  var _getValue, _getValue2, _getValue$split, _getValue3;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var permissionsOverrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  function getValue(key) {
    return getAppInitValue(serverConfig, key);
  }
  function getBooleanValue(key, defaultValue) {
    var value = getValue(key);
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }
    if (value !== undefined) {
      log.warn("Unexpected value for ".concat(key, ": ").concat(value));
    }
    return defaultValue;
  }
  var name = (_getValue = getValue('name')) !== null && _getValue !== void 0 ? _getValue : '';
  var operateAs = (_getValue2 = getValue('operateAs')) !== null && _getValue2 !== void 0 ? _getValue2 : name;
  var groups = (_getValue$split = (_getValue3 = getValue('groups')) === null || _getValue3 === void 0 ? void 0 : _getValue3.split(',')) !== null && _getValue$split !== void 0 ? _getValue$split : [];
  var canCopy = getBooleanValue('canCopy', true);
  var canDownloadCsv = getBooleanValue('canDownloadCsv', true);
  var canUsePanels = getBooleanValue('canUsePanels', true);
  var canLogout = getBooleanValue('canLogout', true);
  return _objectSpread(_objectSpread({
    name,
    operateAs,
    groups
  }, overrides), {}, {
    permissions: _objectSpread({
      canUsePanels,
      canCopy,
      canDownloadCsv,
      canLogout
    }, permissionsOverrides)
  });
}
export default {
  getAppInitValue,
  getUser: getUserFromConfig
};
//# sourceMappingURL=UserUtils.js.map